var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"iframeSel",style:({ width: '100%', minHeight: `${_vm.windowHeight}px`, heigh: 'auto' }),attrs:{"id":"joinedClub","src":_vm.ruta},on:{"load":_vm.loadIframe}})
}
var staticRenderFns = []

export { render, staticRenderFns }